import { colors } from '@shared/tokens/colors.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['size-8'],
    padding: '8px 8px 8px 16px',
    backgroundColor: colors.primaryBackground,
    borderRadius: anatomy.borderRadiusS,
    marginTop: '4px',
  },
  textButton: {
    display: 'flex',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
  text: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    ':hover': {
      color: colors.accentText,
    },
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
});
